import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { EditorView } from '@codemirror/view';
import { CkeditorConstants } from '../../src/utils/ckeditorconstants';

const SOURCE_DIALOG_CLASS = CkeditorConstants.class.CK_SOURCE_EDITING_ENHANCED_DIALOG;
const { CURRENT_SITE_DATA } = CkeditorConstants.localStorageItem;
const TOGGLE_CLASS = 'wk-source-find-replace-toggle';
const FR_DIALOG_CLASS = 'wk-source-find-replace-dialog';
const FR_BACKDROP_CLASS = 'wk-source-find-replace-backdrop';

const FIND_ICON_SVG =
  '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" width="18" height="18" aria-hidden="true">' +
    '<path d="m12.87 13.786 1.532-1.286 3.857 4.596a1 1 0 1 1-1.532 1.286l-3.857-4.596z"/>' +
    '<path d="M16.004 8.5a6.5 6.5 0 0 1-9.216 5.905c-1.154-.53-.863-1.415-.663-1.615.194-.194.564-.592 1.635-.141a4.5 4.5 0 0 0 5.89-5.904l-.104-.227 1.332-1.331c.045-.046.196-.041.224.007a6.47 6.47 0 0 1 .902 3.306zm-3.4-5.715c.562.305.742 1.106.354 1.494-.388.388-.995.414-1.476.178a4.5 4.5 0 0 0-6.086 5.882l.114.236-1.348 1.349c-.038.037-.17.022-.198-.023a6.5 6.5 0 0 1 5.54-9.9 6.469 6.469 0 0 1 3.1.784z"/>' +
    '<path d="M4.001 11.93.948 8.877a.2.2 0 0 1 .141-.341h6.106a.2.2 0 0 1 .141.341L4.283 11.93a.2.2 0 0 1-.282 0zm11.083-6.789 3.053 3.053a.2.2 0 0 1-.14.342H11.89a.2.2 0 0 1-.14-.342l3.052-3.053a.2.2 0 0 1 .282 0z"/>' +
  '</svg>';

const CARET_UP_SVG =
  '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path d="M10 7l-5 6h10z" fill="currentColor"/></svg>';
const CARET_DOWN_SVG =
  '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path d="M10 13l5-6H5z" fill="currentColor"/></svg>';

const STYLES = `
.${TOGGLE_CLASS}{display:inline-flex;align-items:center;justify-content:center;background:transparent;border:1px solid transparent;border-radius:3px;cursor:pointer;padding:6px 6px!important;margin:0 6px;color:var(--ck-color-text,#333);}
.${TOGGLE_CLASS}:hover{background:var(--ck-color-button-default-hover-background,#f0f0f0);}
.${FR_BACKDROP_CLASS}{position:fixed;inset:0;background:transparent;z-index:10000;display:none;}
.${FR_DIALOG_CLASS}{position:fixed;top:120px;right:60px;z-index:10001;display:none;flex-direction:column;width:360px;background:#fff;border:1px solid #d0d0d0;border-radius:4px;box-shadow:0 6px 20px rgba(0,0,0,0.18);font-size:13px;color:#333;font-family:inherit;}
.${FR_DIALOG_CLASS} .wk-fr-header{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;font-weight:600;font-size:15px;cursor:move;user-select:none;}
.${FR_DIALOG_CLASS} .wk-fr-close{background:transparent;border:0;cursor:pointer;font-size:20px;line-height:1;color:#666;padding:0 4px;}
.${FR_DIALOG_CLASS} .wk-fr-body{display:flex;flex-direction:column;gap:10px;padding:0 16px 14px;}
.${FR_DIALOG_CLASS} .wk-fr-input-wrap{position:relative;display:flex;align-items:center;border:1px solid #c4c4c4;border-radius:3px;background:#fff;}
.${FR_DIALOG_CLASS} .wk-fr-input-wrap.wk-fr-focused{border-color:#2680eb;box-shadow:0 0 0 1px #2680eb inset;}
.${FR_DIALOG_CLASS} .wk-fr-input-wrap.wk-fr-readonly{background:#ededed;}
.${FR_DIALOG_CLASS} .wk-fr-input-wrap input{flex:1;border:0;outline:0;padding:14px 10px 6px;background:transparent;font-size:13px;color:#333;min-width:0;}
.${FR_DIALOG_CLASS} .wk-fr-input-wrap .wk-fr-float-label{position:absolute;left:10px;top:50%;transform:translateY(-50%);font-size:13px;color:#888;pointer-events:none;transition:top .12s ease, font-size .12s ease, color .12s ease;background:transparent;padding:0 2px;}
.${FR_DIALOG_CLASS} .wk-fr-input-wrap.wk-fr-floating .wk-fr-float-label{top:9px;font-size:11px;color:#2680eb;}
.${FR_DIALOG_CLASS} .wk-fr-input-wrap.wk-fr-readonly.wk-fr-floating .wk-fr-float-label{color:#888;}
.${FR_DIALOG_CLASS} .wk-fr-count{font-size:12px;color:#888;padding:0 8px;white-space:nowrap;}
.${FR_DIALOG_CLASS} .wk-fr-input-wrap .wk-fr-nav{display:flex;align-items:center;padding-right:4px;color:#888;}
.${FR_DIALOG_CLASS} .wk-fr-input-wrap .wk-fr-nav button{background:transparent;border:0;cursor:pointer;color:inherit;padding:4px 6px;display:inline-flex;align-items:center;justify-content:center;border-radius:3px;}
.${FR_DIALOG_CLASS} .wk-fr-input-wrap .wk-fr-nav button:hover{background:#f0f0f0;color:#333;}
.${FR_DIALOG_CLASS} .wk-fr-input-wrap .wk-fr-nav button:disabled{opacity:.4;cursor:not-allowed;background:transparent;}
.${FR_DIALOG_CLASS} .wk-fr-adv{border-top:1px solid #e6e6e6;border-bottom:2px solid #2680eb;padding-top:6px;}
.${FR_DIALOG_CLASS} .wk-fr-adv-header{display:flex;align-items:center;gap:6px;cursor:pointer;padding:6px 2px;font-weight:600;color:#222;user-select:none;}
.${FR_DIALOG_CLASS} .wk-fr-adv-caret{display:inline-block;transition:transform .15s;color:#666;}
.${FR_DIALOG_CLASS} .wk-fr-adv.collapsed .wk-fr-adv-caret{transform:rotate(-90deg);}
.${FR_DIALOG_CLASS} .wk-fr-adv.collapsed .wk-fr-adv-body{display:none;}
.${FR_DIALOG_CLASS} .wk-fr-adv-body{display:flex;flex-direction:column;gap:8px;padding:6px 2px 10px;}
.${FR_DIALOG_CLASS} .wk-fr-opt{display:flex;align-items:center;justify-content:space-between;}
.${FR_DIALOG_CLASS} .wk-fr-opt-label{color:#333;}
.${FR_DIALOG_CLASS} .wk-fr-switch{position:relative;display:inline-block;width:34px;height:18px;flex:none;}
.${FR_DIALOG_CLASS} .wk-fr-switch input{opacity:0;width:0;height:0;}
.${FR_DIALOG_CLASS} .wk-fr-switch .wk-fr-slider{position:absolute;cursor:pointer;inset:0;background:#c4c4c4;border-radius:18px;transition:.15s;}
.${FR_DIALOG_CLASS} .wk-fr-switch .wk-fr-slider::before{content:"";position:absolute;height:14px;width:14px;left:2px;top:2px;background:#fff;border-radius:50%;transition:.15s;}
.${FR_DIALOG_CLASS} .wk-fr-switch input:checked + .wk-fr-slider{background:#2680eb;}
.${FR_DIALOG_CLASS} .wk-fr-switch input:checked + .wk-fr-slider::before{transform:translateX(16px);}
.${FR_DIALOG_CLASS} .wk-fr-actions{display:flex;justify-content:flex-end;align-items:center;gap:6px;padding:10px 16px 14px;}
.${FR_DIALOG_CLASS} .wk-fr-btn{background:transparent;border:0;padding:6px 10px;font-size:13px;color:#333;cursor:pointer;border-radius:3px;}
.${FR_DIALOG_CLASS} .wk-fr-btn:hover:not(:disabled){background:#f0f0f0;}
.${FR_DIALOG_CLASS} .wk-fr-btn:disabled{color:#aaa;cursor:not-allowed;}
.${FR_DIALOG_CLASS} .wk-fr-btn.wk-fr-primary{background:#26a65b;color:#fff;padding:8px 26px;font-weight:600;border-radius:18px;}
.${FR_DIALOG_CLASS} .wk-fr-btn.wk-fr-primary:hover:not(:disabled){background:#21945a;}
.${FR_DIALOG_CLASS} .wk-fr-btn.wk-fr-primary:disabled{background:#cfe7d8;color:#fff;}
`;

/**
 * Adds a Find & Replace icon button to the SourceEditingEnhanced dialog header.
 * Clicking the button opens a floating dialog that operates exclusively on the
 * underlying CodeMirror EditorView in the source editing modal.
 */
export default class SourceEditingFindAndReplace extends Plugin {
  static get pluginName() {
    return 'SourceEditingFindAndReplace';
  }

  init() {
    const isEnabled = this._resolveEnablement();
    if (!isEnabled) {
      return;
    }

    this._observer = null;
    this._installedFor = new WeakSet();
    this._injectStyles();

    this.editor.on('ready', () => this._startObserving());
    if (this.editor.state === 'ready') {
      this._startObserving();
    }
  }

  _resolveEnablement() {
    const configValue = this.editor.config.get('sourceEditingFindAndReplace');
    if (typeof configValue === 'boolean') {
      return configValue;
    }

    try {
      const currentSiteDataRaw = localStorage.getItem(CURRENT_SITE_DATA);
      if (!currentSiteDataRaw) {
        return false;
      }

      const currentSiteData = JSON.parse(currentSiteDataRaw);
      return !!currentSiteData?.sourceEditingFindAndReplace;
    } catch (_error) {
      return false;
    }
  }

  destroy() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    this._cleanupAll();
    return super.destroy();
  }

  _injectStyles() {
    if (document.getElementById('wk-source-find-replace-styles')) {
      return;
    }
    const style = document.createElement('style');
    style.id = 'wk-source-find-replace-styles';
    style.textContent = STYLES;
    document.head.appendChild(style);
  }

  _startObserving() {
    if (this._observer) {
      return;
    }
    this._scanAndInstall();
    this._observer = new MutationObserver(() => {
      this._scanAndInstall();
      this._scanAndCleanup();
    });
    this._observer.observe(document.body, { childList: true, subtree: true });
  }

  _scanAndInstall() {
    const candidates = document.querySelectorAll(`.${SOURCE_DIALOG_CLASS}`);
    candidates.forEach((node) => {
      const ckDialog = node.closest('.ck-dialog') || node;
      if (ckDialog.hasAttribute('data-fr-owner')) {
        return;
      }
      const cmEl = ckDialog.querySelector('.cm-editor');
      if (!cmEl) {
        return;
      }
      if (this._installedFor.has(ckDialog)) {
        return;
      }
      this._installInto(ckDialog);
      this._installedFor.add(ckDialog);
    });
  }

  _scanAndCleanup() {
    document.querySelectorAll(`.${FR_DIALOG_CLASS}`).forEach((dlg) => {
      const ownerId = dlg.dataset.ownerId;
      if (ownerId && !document.querySelector(`[data-fr-owner="${ownerId}"]`)) {
        const backdrop = document.querySelector(
          `.${FR_BACKDROP_CLASS}[data-owner-id="${ownerId}"]`
        );
        backdrop && backdrop.remove();
        dlg.remove();
      }
    });
  }

  _cleanupAll() {
    document
      .querySelectorAll(`.${TOGGLE_CLASS}, .${FR_DIALOG_CLASS}, .${FR_BACKDROP_CLASS}`)
      .forEach((el) => el.remove());
  }

  _installInto(ckDialog) {
    const ownerId = `wk-fr-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    ckDialog.setAttribute('data-fr-owner', ownerId);

    const { dialogEl, backdropEl } = this._createDialog(ckDialog, ownerId);
    const toggleBtn = this._createToggleButton(dialogEl, backdropEl);

    const header =
      ckDialog.querySelector('.ck-dialog__header') ||
      ckDialog.querySelector('.ck-form__header') ||
      ckDialog.querySelector('.ck-dialog-header');

    if (header) {
      const closeBtn = header.querySelector(
        '.ck-dialog__close, .ck-dialog__action-close, button[aria-label="Close"], button[data-cke-tooltip-text="Close"]'
      );
      if (closeBtn) {
        header.insertBefore(toggleBtn, closeBtn);
      } else {
        header.appendChild(toggleBtn);
      }
    } else {
      const codeContainer =
        ckDialog.querySelector('.ck-code-editor') ||
        (ckDialog.querySelector('.cm-editor') && ckDialog.querySelector('.cm-editor').parentElement);
      if (codeContainer && codeContainer.parentElement) {
        const wrap = document.createElement('div');
        wrap.style.cssText = 'display:flex;justify-content:flex-end;padding:4px 8px;';
        wrap.appendChild(toggleBtn);
        codeContainer.parentElement.insertBefore(wrap, codeContainer);
      } else {
        ckDialog.insertBefore(toggleBtn, ckDialog.firstChild);
      }
    }
  }

  _createToggleButton(dialogEl, backdropEl) {
    const toggleBtn = document.createElement('button');
    toggleBtn.type = 'button';
    toggleBtn.className = TOGGLE_CLASS;
    toggleBtn.title = 'Find and replace (source)';
    toggleBtn.setAttribute('aria-label', 'Find and replace');
    toggleBtn.innerHTML = FIND_ICON_SVG;
    toggleBtn.addEventListener('click', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      const isHidden = dialogEl.style.display === 'none' || !dialogEl.style.display;
      if (isHidden) {
        backdropEl.style.display = 'block';
        dialogEl.style.display = 'flex';
        const findInput = dialogEl.querySelector('.wk-find-input');
        const replaceInput = dialogEl.querySelector('.wk-replace-input');
        if (findInput) {
          findInput.value = '';
          replaceInput.value = '';
          findInput.dispatchEvent(new Event('input'));
          findInput.focus();
          findInput.select();
        }
      } else {
        backdropEl.style.display = 'none';
        dialogEl.style.display = 'none';
      }
    });
    return toggleBtn;
  }

  _createDialog(ckDialog, ownerId) {
    const backdropEl = document.createElement('div');
    backdropEl.className = FR_BACKDROP_CLASS;
    backdropEl.dataset.ownerId = ownerId;

    const dialogEl = document.createElement('div');
    dialogEl.className = FR_DIALOG_CLASS;
    dialogEl.dataset.ownerId = ownerId;
    dialogEl.setAttribute('role', 'dialog');
    dialogEl.setAttribute('aria-label', 'Find and replace');
    dialogEl.innerHTML = `
      <div class="wk-fr-header">
        <span>Find and replace</span>
        <button type="button" class="wk-fr-close" aria-label="Close">&times;</button>
      </div>
      <div class="wk-fr-body">
        <div class="wk-fr-input-wrap">
          <input type="text" class="wk-find-input" placeholder=" ">
          <span class="wk-fr-float-label">Find in text...</span>
          <span class="wk-fr-count" aria-live="polite"></span>
          <div class="wk-fr-nav">
            <button type="button" class="wk-prev" title="Previous match" aria-label="Previous match">${CARET_UP_SVG}</button>
            <button type="button" class="wk-next" title="Next match" aria-label="Next match">${CARET_DOWN_SVG}</button>
          </div>
        </div>
        <div class="wk-fr-input-wrap wk-fr-readonly">
          <input type="text" class="wk-replace-input" placeholder=" ">
          <span class="wk-fr-float-label">Replace with...</span>
        </div>
        <div class="wk-fr-adv collapsed">
          <div class="wk-fr-adv-header" role="button" tabindex="0" aria-expanded="false">
            <span class="wk-fr-adv-caret">${CARET_DOWN_SVG}</span>
            <span>Advanced options</span>
          </div>
          <div class="wk-fr-adv-body">
            <div class="wk-fr-opt">
              <span class="wk-fr-opt-label">Match case</span>
              <label class="wk-fr-switch">
                <input type="checkbox" class="wk-match-case">
                <span class="wk-fr-slider"></span>
              </label>
            </div>
            <div class="wk-fr-opt">
              <span class="wk-fr-opt-label">Whole words only</span>
              <label class="wk-fr-switch">
                <input type="checkbox" class="wk-whole-words">
                <span class="wk-fr-slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="wk-fr-actions">
        <button type="button" class="wk-fr-btn wk-replace-all">Replace all</button>
        <button type="button" class="wk-fr-btn wk-replace">Replace</button>
        <button type="button" class="wk-fr-btn wk-fr-primary wk-find-btn">Find</button>
      </div>
    `;

    document.body.appendChild(backdropEl);
    document.body.appendChild(dialogEl);

    this._wireDialog(dialogEl, backdropEl, ckDialog);
    return { dialogEl, backdropEl };
  }

  _wireDialog(dialogEl, backdropEl, ckDialog) {
    const findInput = dialogEl.querySelector('.wk-find-input');
    const replaceInput = dialogEl.querySelector('.wk-replace-input');
    const matchCaseInput = dialogEl.querySelector('.wk-match-case');
    const wholeWordsInput = dialogEl.querySelector('.wk-whole-words');
    const countEl = dialogEl.querySelector('.wk-fr-count');

    const prevBtn = dialogEl.querySelector('.wk-prev');
    const nextBtn = dialogEl.querySelector('.wk-next');
    const findBtn = dialogEl.querySelector('.wk-find-btn');
    const replaceBtn = dialogEl.querySelector('.wk-replace');
    const replaceAllBtn = dialogEl.querySelector('.wk-replace-all');

    const advRoot = dialogEl.querySelector('.wk-fr-adv');
    const advHeader = dialogEl.querySelector('.wk-fr-adv-header');

    const state = { matches: [], currentIndex: -1, dirty: true };

    this._wireFloatingLabel(findInput);
    this._wireFloatingLabel(replaceInput);

    const closeDialog = () => {
      dialogEl.style.display = 'none';
      backdropEl.style.display = 'none';
    };

    const isWordChar = (ch) => /[\w]/.test(ch || '');

    const computeMatches = () => {
      const view = this._getCmView(ckDialog);
      const query = findInput.value;
      const result = [];
      if (!view || !query) {
        return { view, matches: result };
      }
      const text = view.state.doc.toString();
      const haystack = matchCaseInput.checked ? text : text.toLowerCase();
      const needle = matchCaseInput.checked ? query : query.toLowerCase();
      const useWhole = wholeWordsInput.checked;
      let i = 0;
      const step = needle.length || 1;
      while (i <= haystack.length) {
        const idx = haystack.indexOf(needle, i);
        if (idx === -1) {
          break;
        }
        if (useWhole) {
          const before = idx > 0 ? text[idx - 1] : '';
          const after = idx + query.length < text.length ? text[idx + query.length] : '';
          if (!isWordChar(before) && !isWordChar(after)) {
            result.push({ from: idx, to: idx + query.length });
          }
        } else {
          result.push({ from: idx, to: idx + query.length });
        }
        i = idx + step;
      }
      return { view, matches: result };
    };

    const refreshState = () => {
      const { view, matches } = computeMatches();
      state.matches = matches;
      state.currentIndex = matches.length ? 0 : -1;
      state.dirty = false;
      this._highlight(view, matches[0]);
      updateButtons();
    };

    const updateButtons = () => {
      const hasQuery = !!findInput.value;
      const hasMatches = state.matches.length > 0 && state.currentIndex >= 0;
      findBtn.disabled = !hasQuery;
      prevBtn.disabled = !hasMatches;
      nextBtn.disabled = !hasMatches;
      replaceBtn.disabled = !hasMatches;
      replaceAllBtn.disabled = !hasMatches;
      if (!hasQuery || state.dirty) {
        countEl.textContent = '';
      } else if (!state.matches.length) {
        countEl.textContent = '0 of 0';
      } else {
        countEl.textContent = `${state.currentIndex + 1} of ${state.matches.length}`;
      }
    };

    const goTo = (offset) => {
      if (state.dirty) {
        refreshState();
        return;
      }
      if (!state.matches.length) {
        return;
      }
      const view = this._getCmView(ckDialog);
      state.currentIndex =
        (state.currentIndex + offset + state.matches.length) % state.matches.length;
      this._highlight(view, state.matches[state.currentIndex]);
      updateButtons();
    };

    const findAction = () => {
      if (state.dirty) {
        refreshState();
      } else {
        goTo(1);
      }
    };

    const replaceCurrent = () => {
      if (state.dirty) {
        refreshState();
        return;
      }
      const view = this._getCmView(ckDialog);
      if (!view || state.currentIndex < 0) {
        return;
      }
      const match = state.matches[state.currentIndex];
      view.dispatch({
        changes: { from: match.from, to: match.to, insert: replaceInput.value }
      });
      state.dirty = true;
      refreshState();
    };

    const replaceAll = () => {
      if (state.dirty) {
        refreshState();
      }
      const view = this._getCmView(ckDialog);
      if (!view || !state.matches.length) {
        return;
      }
      const insert = replaceInput.value;
      const changes = state.matches.map((m) => ({ from: m.from, to: m.to, insert }));
      view.dispatch({ changes });
      state.dirty = true;
      refreshState();
    };

    const markDirty = () => {
      state.dirty = true;
      updateButtons();
    };

    findInput.addEventListener('input', markDirty);
    matchCaseInput.addEventListener('change', markDirty);
    wholeWordsInput.addEventListener('change', markDirty);

    nextBtn.addEventListener('click', () => goTo(1));
    prevBtn.addEventListener('click', () => goTo(-1));
    findBtn.addEventListener('click', findAction);
    replaceBtn.addEventListener('click', replaceCurrent);
    replaceAllBtn.addEventListener('click', replaceAll);
    dialogEl.querySelector('.wk-fr-close').addEventListener('click', closeDialog);
    backdropEl.addEventListener('click', closeDialog);

    advHeader.addEventListener('click', () => this._toggleAdvanced(advRoot, advHeader));
    advHeader.addEventListener('keydown', (evt) => {
      if (evt.key === 'Enter' || evt.key === ' ') {
        evt.preventDefault();
        this._toggleAdvanced(advRoot, advHeader);
      }
    });

    findInput.addEventListener('keydown', (evt) => {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        if (evt.shiftKey) {
          goTo(-1);
        } else {
          findAction();
        }
      } else if (evt.key === 'Escape') {
        evt.preventDefault();
        closeDialog();
      }
    });
    replaceInput.addEventListener('keydown', (evt) => {
      if (evt.key === 'Enter') {
        evt.preventDefault();
        replaceCurrent();
      } else if (evt.key === 'Escape') {
        evt.preventDefault();
        closeDialog();
      }
    });

    updateButtons();
    this._enableDrag(dialogEl);
  }

  _toggleAdvanced(advRoot, advHeader) {
    const collapsed = advRoot.classList.toggle('collapsed');
    advHeader.setAttribute('aria-expanded', String(!collapsed));
  }

  _wireFloatingLabel(inputEl) {
    const wrap = inputEl.closest('.wk-fr-input-wrap');
    if (!wrap) {
      return;
    }
    const sync = () => {
      const focused = document.activeElement === inputEl;
      const hasValue = !!inputEl.value;
      wrap.classList.toggle('wk-fr-focused', focused);
      wrap.classList.toggle('wk-fr-floating', focused || hasValue);
    };
    inputEl.addEventListener('focus', sync);
    inputEl.addEventListener('blur', sync);
    inputEl.addEventListener('input', sync);
    sync();
  }

  _enableDrag(dialogEl) {
    const handle = dialogEl.querySelector('.wk-fr-header');
    if (!handle) {
      return;
    }
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startTop = 0;
    let dragging = false;

    const onMouseMove = (evt) => {
      if (!dragging) {
        return;
      }
      const dx = evt.clientX - startX;
      const dy = evt.clientY - startY;
      dialogEl.style.left = `${startLeft + dx}px`;
      dialogEl.style.top = `${startTop + dy}px`;
      dialogEl.style.right = 'auto';
    };

    const onMouseUp = () => {
      dragging = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    handle.addEventListener('mousedown', (evt) => {
      if (evt.target.closest('.wk-fr-close')) {
        return;
      }
      const rect = dialogEl.getBoundingClientRect();
      startX = evt.clientX;
      startY = evt.clientY;
      startLeft = rect.left;
      startTop = rect.top;
      dragging = true;
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });
  }

  _getCmView(ckDialog) {
    const cmEl = ckDialog.querySelector('.cm-editor');
    if (!cmEl) {
      return null;
    }
    return EditorView.findFromDOM(cmEl);
  }

  _highlight(view, match) {
    if (!view || !match) {
      return;
    }
    view.dispatch({
      selection: { anchor: match.from, head: match.to },
      scrollIntoView: true
    });
  }
}